export const DEFAULT_APP_NAME = 'Sable';
